import i18n from "@/i18n.ts";
import { PipelineStageTypes } from "@/types/recruit/stages.types.ts";
import { SelectItem } from "@skailer-com/uikit";

export const getPipelineStageTimeLimits = (): SelectItem[] => {
  return Array.from({ length: 31 }, (_, index) => {
    return index === 0
      ? { id: index.toString(), title: i18n.t("ats:no_time_limit") }
      : { id: index.toString(), title: i18n.t("plurals:plural_day", { count: index }) };
  });
};

export interface ApiStageInPipelineEdit {
  id: number;
  title: string;
  sla_limit: string;
  selected: boolean;
  type: PipelineStageTypes;
}
